<template>
    <div class="unit-info-prometheus__wrap">

        <div class="unit-info-prometheus__header page-block">
            <div class="unit-info-prometheus__box" style="flex-direction: column">
                <div class="unit-info-prometheus__box-item flex align-items-canter flex-gap-10">
                        <span class="unit-info-prometheus__icon">
                            <SvgIcon name="car" class="icon"/>
                        </span>
                    <div class="unit-info-prometheus__title">{{unit?.name}}:</div>
                </div>
                <UnitInfo_indicators
                    class="unit-info-prometheus__box-item flex align-items-canter flex-gap-10"
                    :unitId="unitId"
                    :indicators="pageParams.indicators"
                />
            </div>
            <div class="unit-info-prometheus__box unit-info-prometheus__address">
                <UnitInfo__address :unitId="unitId"/>
            </div>
        </div>

        <UnitInfo__sensors
            class="unit-info-prometheus__sensors page-block"
            :sensors="pageParams.sensors"
            :hideSensorByValue="true"
            :unitId="unitId"
        />

        <!--    border    -->
        <div class="default-border-bottom page-block"></div>

        <TabsControlByRoute class="page-block" :list="pageParams.menuList"/>

        <div class="default-border-bottom page-block"></div>

        <div id="sectionInfoByPage" class="page-block"></div>
    </div>
</template>

<script>
import consts from "@/consts";
import {mapGetters} from "vuex";
import UnitInfo_indicators from "@/components/units/info/indicators/UnitInfo_indicators.vue";
import UnitInfo__address from "@/components/units/info/UnitInfo__address.vue";
import TabsControlByRoute from "@/components/_base/TabsControlByRoute.vue";
import UnitInfo__sensors from "@/components/units/info/UnitInfo__sensors.vue";
import unitLmsgMixin from "@/mixins/unitLmsgMixin";

export default {
    setup() {
        return {
            defaultAccordionInfo: ['sensors'],
        }
    },
    name: "UnitInfo_content_base",
    mixins: [unitLmsgMixin],
    inject: ['fnAddPageClass','fnRemovePageClass'],
    props: {
        unitId: Number,
    },
    components: {
        TabsControlByRoute,
        UnitInfo__address,
        UnitInfo_indicators,
        UnitInfo__sensors,
    },
    data() {
        return {
            activeType: 'video',
            component: '',
            components: [
                {id: '', name: ''}
            ],
        }
    },
    computed: {
        ...mapGetters([
            "getWindowWidth",
        ]),
        routesList() {
            let obj = {
                'info': {name: this.$t('Unit.menu.Info'), route_name: consts.routerNames?.units?.type[this.routeTemplate]?.info, setRoute: () => this.setRoute.unitId(this.$route, this.$router, this.unitId),icon: 'common__info'},
                'track': {name: this.$t('Unit.menu.Track'), route_name: consts.routerNames.units.track.main, setRoute: () => this.setRoute.track(this.$route, this.$router, this.unitId), icon: 'build-track'},
                'report': {name: this.$t('Unit.menu.Report'), route_name: '', icon: 'reports'},
                'fuel': {name: this.$t('Unit.menu.Fuel'), route_name: '', icon: 'tab-fuel'},
                'chart': {name: this.$t('Unit.menu.Chart'), route_name: '', icon: 'chart'},
                'edit': {name: this.$t('Unit.menu.Edit'), route_name: consts.routerNames.units.edit.main, icon: 'command__edit'},
            }

            if(this.isUnitFullLoad) {
                obj.edit['setRoute'] = () => this.setRoute.unitEdit(this.$route, this.$router, this.unitId)
            }

            return obj;
        },
        pageParamsByUnitType() {
            //ToDo fix
            let defautlIndicators = ['connection', 'movement', 'ignition'];
            if(this.hasVideo) {
                defautlIndicators.push('camera')
            }
            return {
                default: {
                    menuList: [this.routesList.info],
                    indicators: ['connection']
                },
                xvision : {
                    menuList: [this.routesList.info, this.routesList.track, this.routesList.edit],//this.routesList.report, this.routesList.chart,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                xtrack : {
                    menuList: [this.routesList.info, this.routesList.track, this.routesList.edit],//this.routesList.report, this.routesList.chart,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                xcool : {
                    menuList: [this.routesList.info, this.routesList.track, this.routesList.edit],//this.routesList.report, this.routesList.chart,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                xpower : {
                    menuList: [this.routesList.info, this.routesList.track, this.routesList.edit],//this.routesList.report, this.routesList.chart,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                xcargo : {
                    menuList: [this.routesList.info, this.routesList.track, this.routesList.edit],//this.routesList.report, this.routesList.chart,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                xlink : {
                    menuList: [this.routesList.info, this.routesList.track, this.routesList.edit],//this.routesList.report, this.routesList.chart,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                pro_cargo_vision : {
                    menuList: [this.routesList.info, this.routesList.track, this.routesList.edit],//this.routesList.report, this.routesList.chart,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                xbles : {
                    menuList: [this.routesList.info, this.routesList.track,this.routesList.edit]
                        .filter(i => this.isStationaryObj ? i !== this.routesList.track : true),//this.routesList.track, this.routesList.report, this.routesList.chart,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                obd : {
                    menuList: [this.routesList.info, this.routesList.track, this.routesList.edit],//this.routesList.report, this.routesList.chart,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                m2m : {
                    menuList: [this.routesList.info, this.routesList.track, this.routesList.edit],//this.routesList.report, this.routesList.chart,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                m2m_chassis : {
                    menuList: [this.routesList.info, this.routesList.track, this.routesList.edit],//this.routesList.report, this.routesList.chart,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                sensors : {
                    menuList: [this.routesList.info, this.routesList.track, this.routesList.edit],//this.routesList.report, this.routesList.chart,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
            }
        },
        hideInfoUnit() {
            return this.routeMeta.hideInfoUnit
        },
        pageParams() {
            return this.pageParamsByUnitType[this.routeTemplate] || this.pageParamsByUnitType.default
        },
    },
}
</script>

<style lang="scss">
@import "@/scss/02-components/unit-info-prometheus.scss";
</style>